import React, { createContext, useContext, useState } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [analyzeOpen, setAnalyzeOpen] = useState(false);
  const [premiumOpen, setPremiumOpen] = useState(false);

  return (
    <UIContext.Provider
      value={{
        analyzeOpen,
        premiumOpen,
        openAnalyze: () => setAnalyzeOpen(true),
        closeAnalyze: () => setAnalyzeOpen(false),
        openPremium: () => setPremiumOpen(true),
        closePremium: () => setPremiumOpen(false),
      }}
    >
      {children}
    </UIContext.Provider>
  );
}

export const useUI = () => useContext(UIContext);
